import {fetchQuery, type GraphQLTaggedNode, type OperationType} from 'relay-runtime'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {clientSideRelayFetchQueryRetained} from '@github-ui/relay-environment'

export const DEFAULT_RELAY_CACHE_TTL = 2 * 7 * 24 * 60 * 60 * 1000 // 2 weeks in milliseconds

export function fetchQueryWithCache<T extends OperationType>(...args: [...Parameters<typeof fetchQuery<T>>, number?]) {
  const [environment, query, variables, options, ttl] = args
  const defaultValues = getDefaultValues(query)
  return fetchQuery<T>(environment, query, variables, {
    ...options,
    networkCacheConfig: {metadata: {ttl, defaultValues}},
  })
}

export function clientSideRelayFetchQueryRetainedWithCache<T extends OperationType>(
  ...args: [...Parameters<typeof clientSideRelayFetchQueryRetained<T>>, number?]
) {
  const [options, ttl] = args
  const defaultValues = getDefaultValues(options.query)

  return clientSideRelayFetchQueryRetained<T>({
    ...options,
    metadata: {...options.metadata, ttl, defaultValues},
  })
}

export function getDefaultValues(query: GraphQLTaggedNode): Record<string, unknown> | undefined {
  const defaultValues: Record<string, unknown> = {}
  if ('operation' in query) {
    const argumentDefinitions = query.operation.argumentDefinitions
    for (const argDef of argumentDefinitions) {
      if (argDef.defaultValue !== undefined && argDef.defaultValue !== null) {
        defaultValues[argDef.name] = argDef.defaultValue
      }
    }
  }
  return Object.keys(defaultValues).length > 0 ? defaultValues : undefined
}
